import { createContext, useContext, useState, useEffect, useCallback } from 'react'
import { platformAuthApi } from '../services/platformApi'

const PlatformAuthContext = createContext(null)

export function PlatformAuthProvider({ children }) {
  const [admin, setAdmin]     = useState(() => {
    try { return JSON.parse(localStorage.getItem('platform_user')) } catch { return null }
  })
  const [loading, setLoading] = useState(true)

  // Verify the stored token still works on mount.
  useEffect(() => {
    const token = localStorage.getItem('platform_token')
    if (!token) { setLoading(false); return }

    platformAuthApi.me()
      .then(({ data }) => {
        setAdmin(data.data)
        localStorage.setItem('platform_user', JSON.stringify(data.data))
      })
      .catch(() => {
        localStorage.removeItem('platform_token')
        localStorage.removeItem('platform_user')
        setAdmin(null)
      })
      .finally(() => setLoading(false))
  }, [])

  const login = useCallback(async (email, password) => {
    const { data } = await platformAuthApi.login({ email, password })
    localStorage.setItem('platform_token', data.data.token)
    localStorage.setItem('platform_user',  JSON.stringify(data.data.user))
    setAdmin(data.data.user)
    return data.data.user
  }, [])

  const logout = useCallback(async () => {
    try { await platformAuthApi.logout() } catch {}
    localStorage.removeItem('platform_token')
    localStorage.removeItem('platform_user')
    setAdmin(null)
  }, [])

  return (
    <PlatformAuthContext.Provider value={{ admin, loading, login, logout }}>
      {children}
    </PlatformAuthContext.Provider>
  )
}

export const usePlatformAuth = () => {
  const ctx = useContext(PlatformAuthContext)
  if (!ctx) throw new Error('usePlatformAuth must be used within PlatformAuthProvider')
  return ctx
}
